/**
 * Keeps sample and regular cart items separated when the theme can validate it.
 * Fallback policy: never block the original cart action or checkout if a check
 * or cleanup fails.
 */
(function () {
  if (window.__fpCartSampleManagerLoaded) return;
  window.__fpCartSampleManagerLoaded = true;

  var ignoredSources = {
    'sample-product-card': true,
    'sample-widget-add': true,
    'sample-widget-remove': true,
    'cart-sample-manager': true,
  };

  var isReconciling = false;
  var pendingReconcile = false;

  function rootUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.endsWith('/') ? root : root + '/';
  }

  function cartJsonUrl() {
    return rootUrl() + 'cart.js';
  }

  function cartUpdateUrl() {
    return (window.routes && window.routes.cart_update_url) || rootUrl() + 'cart/update.js';
  }

  function isSampleItem(item) {
    return Boolean(item && item.properties && item.properties._is_sample === 'true');
  }

  function hasMixedCart(cart) {
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return false;

    var sampleCount = 0;
    var regularCount = 0;
    cart.items.forEach(function (item) {
      if (isSampleItem(item)) {
        sampleCount += 1;
      } else {
        regularCount += 1;
      }
    });

    return sampleCount > 0 && regularCount > 0;
  }

  function collectCartSectionIds() {
    var ids = [];
    if (document.getElementById('CartDrawer')) ids.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
    return ids;
  }

  async function fetchCart() {
    try {
      var response = await fetch(cartJsonUrl(), { headers: { Accept: 'application/json' } });
      if (!response.ok) return null;
      return await response.json();
    } catch (error) {
      console.warn('[FP] cart-sample-manager: cart check failed; leaving cart unchanged.', error);
      return null;
    }
  }

  async function resolveCart(event) {
    var eventCart = event && event.detail && event.detail.resource;
    if (eventCart && Array.isArray(eventCart.items)) return eventCart;
    return fetchCart();
  }

  async function removeSampleLines(cart, keepalive) {
    var updates = {};

    cart.items.forEach(function (item) {
      if (isSampleItem(item) && item.key) {
        updates[item.key] = 0;
      }
    });

    if (Object.keys(updates).length === 0) return null;

    var sectionIds = collectCartSectionIds();
    var body = { updates: updates };
    if (sectionIds.length > 0) {
      body.sections = sectionIds.join(',');
      body.sections_url = window.location.pathname + window.location.search;
    }

    var response = await fetch(cartUpdateUrl(), {
      method: 'POST',
      keepalive: Boolean(keepalive),
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) throw new Error('Cart update failed: ' + response.status);
    return response.json();
  }

  function dispatchCartUpdate(updatedCart) {
    if (!updatedCart) return;

    var sections = updatedCart.sections || {};
    var cartBubble = document.getElementById('cart-icon-bubble');
    if (cartBubble && sections['cart-icon-bubble']) {
      var bubbleDocument = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var bubbleContent = bubbleDocument.querySelector('.shopify-section');
      if (bubbleContent) cartBubble.innerHTML = bubbleContent.innerHTML;
    }

    var cartDrawer = document.getElementById('CartDrawer');
    if (cartDrawer && sections['cart-drawer']) {
      var drawerDocument = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var drawerContent = drawerDocument.getElementById('CartDrawer');
      if (drawerContent) cartDrawer.innerHTML = drawerContent.innerHTML;
    }

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'cart-sample-manager',
        cartData: updatedCart,
      });
    }

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: updatedCart,
          sourceId: 'cart-sample-manager',
          data: {
            source: 'cart-sample-manager',
            itemCount: updatedCart.item_count,
            sections: updatedCart.sections || {},
          },
        },
      })
    );
  }

  async function reconcileCart(reason, event, options) {
    if (isReconciling) {
      pendingReconcile = true;
      return;
    }

    isReconciling = true;

    try {
      var cart = await resolveCart(event);
      if (!hasMixedCart(cart)) return;

      var updatedCart = await removeSampleLines(cart, options && options.keepalive);
      dispatchCartUpdate(updatedCart);
    } catch (error) {
      console.warn('[FP] cart-sample-manager: cleanup failed; keeping cart usable.', reason, error);
    } finally {
      isReconciling = false;

      if (pendingReconcile) {
        pendingReconcile = false;
        window.setTimeout(function () {
          reconcileCart('pending');
        }, 0);
      }
    }
  }

  function scheduleReconcile(reason, event) {
    window.setTimeout(function () {
      reconcileCart(reason, event);
    }, 0);
  }

  function renderedCartMayHaveItems() {
    var cartBubble = document.getElementById('cart-icon-bubble');
    if (!cartBubble) return true;
    return Boolean(cartBubble.querySelector('.cart-count-bubble'));
  }

  document.addEventListener('cart:update', function (event) {
    var source = event && event.detail && event.detail.data && event.detail.data.source;
    if (ignoredSources[source]) return;
    scheduleReconcile('cart:update', event);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (ignoredSources[event && event.source]) return;
      scheduleReconcile('cart-update', {
        detail: {
          resource: event && event.cartData,
        },
      });
    });
  }

  function scheduleLoadReconcile() {
    if (!renderedCartMayHaveItems()) return;
    scheduleReconcile('load');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleLoadReconcile);
  } else {
    scheduleLoadReconcile();
  }

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    scheduleReconcile('pageshow');
  });

  document.addEventListener(
    'dialog:open',
    function (event) {
      if (event.target instanceof Element && event.target.closest('cart-drawer, .cart-drawer')) {
        scheduleReconcile('cart-drawer-open');
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      if (
        target.closest(
          'button[name="checkout"], [name="checkout"], .cart__checkout-button, shopify-accelerated-checkout-cart'
        )
      ) {
        reconcileCart('checkout-intent', null, { keepalive: true });
        return;
      }

      if (
        target.closest(
          '#cart-icon-bubble, .header__icon--cart, a[href$="/cart"]'
        )
      ) {
        scheduleReconcile('cart-open-intent');
      }
    },
    true
  );
})();
